import { useEffect, useRef } from 'react'
import styles from './CampaignSaveSuccessModal.module.css'

export function CampaignSaveSuccessModal() {
  const dialogRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const previousFocus = document.activeElement as HTMLElement | null
    dialogRef.current?.focus()

    return () => {
      if (previousFocus?.isConnected) previousFocus.focus()
    }
  }, [])

  return (
    <div className={styles.overlay}>
      <div
        ref={dialogRef}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-labelledby="campaign-save-success-title"
        aria-describedby="campaign-save-success-description"
        tabIndex={-1}
      >
        <div className={styles.icon} aria-hidden="true">
          <svg viewBox="0 0 64 64" fill="none">
            <circle className={styles.iconCircle} cx="32" cy="32" r="27" />
            <path className={styles.iconCheck} d="m20 32 8 8 17-18" />
          </svg>
        </div>
        <h2 id="campaign-save-success-title" className={styles.title}>
          Campanha atualizada com sucesso
        </h2>
        <p id="campaign-save-success-description" className={styles.description}>
          Suas alterações foram salvas.
        </p>
        <div className={styles.progress} aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  )
}
